import en from 'date-fns/locale/en';
import { createContext } from 'react';

export const SchedulerContext = createContext({ locale: en });
